// extracted by mini-css-extract-plugin
export default {"result":"FinishDateCell_result__e5BBw","subTitle":"FinishDateCell_subTitle__3Jy9g"};